var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateIdeas({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 118,
    height: 105,
    viewBox: "0 0 118 105",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4512 35.9899C71.0812 35.9899 62.5612 35.6499 54.5912 33.4299C46.7712 31.2599 39.5912 27.0499 33.1912 22.1799C29.0012 19.0099 25.1912 16.4899 19.7512 16.8699C14.4247 17.1615 9.3336 19.1601 5.23121 22.5699C-1.68879 28.5699 -0.648793 39.7999 2.12121 47.6899C6.28121 59.5699 18.9412 67.7999 29.7012 73.1799C42.1312 79.3899 55.7912 82.9899 69.4812 85.0699C81.4812 86.8899 96.9012 88.2199 107.301 80.3799C116.851 73.1799 119.471 56.7399 117.131 45.6399C116.564 42.3578 114.818 39.3957 112.221 37.3099C105.511 32.4099 95.5012 35.6799 87.9612 35.8499C85.1612 35.9099 82.3112 35.9799 79.4512 35.9899Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.9712 104.52C79.2456 104.52 95.6812 103.495 95.6812 102.23C95.6812 100.965 79.2456 99.9399 58.9712 99.9399C38.6969 99.9399 22.2612 100.965 22.2612 102.23C22.2612 103.495 38.6969 104.52 58.9712 104.52Z",
    fill: "#F2F2F2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.33132 71.9999C6.87256 71.9999 7.31132 71.5612 7.31132 71.0199C7.31132 70.4787 6.87256 70.0399 6.33132 70.0399C5.79008 70.0399 5.35132 70.4787 5.35132 71.0199C5.35132 71.5612 5.79008 71.9999 6.33132 71.9999Z",
    fill: "#CFCFCF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.5713 84.4299V88.7399",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M46.4211 86.59H50.7211",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M100.201 16.6499H17.7313C15.5995 16.6499 13.8713 18.3781 13.8713 20.5099V77.0799C13.8713 79.2117 15.5995 80.9399 17.7313 80.9399H100.201C102.333 80.9399 104.061 79.2117 104.061 77.0799V20.5099C104.061 18.3781 102.333 16.6499 100.201 16.6499Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.9012 33.75H26.0212C24.4969 33.75 23.2612 34.9857 23.2612 36.51V72.46C23.2612 73.9843 24.4969 75.22 26.0212 75.22H91.9012C93.4255 75.22 94.6612 73.9843 94.6612 72.46V36.51C94.6612 34.9857 93.4255 33.75 91.9012 33.75Z",
    fill: "white",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M104.061 27.4799V20.57C104.063 20.0622 103.964 19.5592 103.77 19.0897C103.577 18.6202 103.293 18.1935 102.934 17.8341C102.576 17.4746 102.15 17.1893 101.681 16.9947C101.212 16.8001 100.709 16.6999 100.201 16.7H17.7313C17.2236 16.6999 16.7208 16.8001 16.2519 16.9947C15.7829 17.1893 15.3569 17.4746 14.9984 17.8341C14.6398 18.1935 14.3557 18.6202 14.1623 19.0897C13.9689 19.5592 13.87 20.0622 13.8714 20.57V27.57L104.061 27.4799Z",
    fill: "#D2D2D2"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9712 10.1599V22.6099",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M76.9712 10.1599V22.6099",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3413 10.9899C90.8826 10.9899 91.3213 10.5511 91.3213 10.0099C91.3213 9.46867 90.8826 9.02991 90.3413 9.02991C89.8001 9.02991 89.3613 9.46867 89.3613 10.0099C89.3613 10.5511 89.8001 10.9899 90.3413 10.9899Z",
    fill: "#CFCFCF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1013 11.8499C29.6426 11.8499 30.0813 11.4111 30.0813 10.8699C30.0813 10.3287 29.6426 9.88989 29.1013 9.88989C28.5601 9.88989 28.1213 10.3287 28.1213 10.8699C28.1213 11.4111 28.5601 11.8499 29.1013 11.8499Z",
    fill: "#CFCFCF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1812 4.38V8.68001",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0312 6.52991H56.3313",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M9.10132 0.5V4.8",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.95117 2.6499H11.2612",
    stroke: "#BABABA",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateIdeas);
export default __webpack_public_path__ + "static/media/empty-state-ideas.21bc7b07a8ca9f1723b2c8ab14ce3a8f.svg";
export { ForwardRef as ReactComponent };